// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { _ } from "~/i18n";

export default class Groomer extends Content {
	_build() {
		this._dom.container.classList.add("content-groomer");

		const frag = Mapy.Util.fragment();

		// posledni aktualizace a typ
		const intl = new Intl.DateTimeFormat("cs", {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
		});
		const lastTime = new Date(this._data.time * 1000);
		// TODO: existuji dalsi 2 druhy vozidel a neni pro ne ikona
		const icon = this._data.vehicleType == "scooter" || this._data.vehicleType == "quadBike" ? "skutr" : "rolba";
		frag.appendChild(Mapy.Util.node("p", {
			className: "last-change",
			innerHTML: `<img role="presentation" alt="" src="/img/detail/${icon}.svg" />${_("detail.content.groomer.lastChange", { lastChange: intl.format(lastTime) })}`
		}));

		// barvicky stari
		const age = Mapy.Util.node("div", { className: "age" });
		age.appendChild(Mapy.Util.node("p", { innerHTML: _("detail.content.groomer.age") }));
		if (this._data.source) {
			age.appendChild(Mapy.Util.node("p", { className: "source", innerHTML: `${_("detail.content.groomer.source")}: <a href="${this._data.source.url}" rel="noopener noreferer" target="_blank">${this._data.source.text}</a>` }));
		}
		frag.appendChild(age);
		const legend = Mapy.Util.node("ul", { className: "legend" });
		[{
			title: _("detail.content.groomer.day1"),
			age: 1,
		}, {
			title: _("detail.content.groomer.day3"),
			age: 3,
		}, {
			title: _("detail.content.groomer.day7"),
			age: 7,
		}, {
			title: _("detail.content.groomer.unknown"),
			age: -1,
		}].forEach((range, index) => {
			const li = Mapy.Util.node("li", { className: `range-${index + 1}`, innerHTML: range.title });
			if (range.age === this._data.age) {
				li.classList.add("active");
			}
			legend.appendChild(li);
		});
		frag.appendChild(legend);

		this._dom.container.appendChild(frag);
	}
};
